import { AfterViewInit, Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { CustomValidators } from 'ngx-custom-validators';
import { SalesPersonService } from 'src/app/services/crew-services/sales-person.service';
import { TargetService } from 'src/app/services/target.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-assign-targets',
  templateUrl: './assign-targets.component.html',
  styleUrls: ['./assign-targets.component.css']
})
export class AssignTargetsComponent implements OnInit, AfterViewInit {
  @Input() target: any;
  @Input() fromSalesPerson: boolean = false;
  @Input() salesperson: any;
  @Input() targets: any;
  @Input() isTeam: boolean = false;
  @ViewChild('closeAssignTargetModal') closeAssignTargetModal!: ElementRef;
  assignTargetForm!: FormGroup;
  showTargetModal: boolean = false;
  salespersonList: any;
  targetStageList: any;
  private _isCurrencyEnabledForAssigned!: boolean;
  target_limit: any;
  loading: boolean = false;
  loadingView: boolean = false;
  periods!: Observable<any>;
  subperiods: any;
  selectedTarget: any;
  constructor(
    public generalService: GeneralService,
    private salepersonSrv: SalesPersonService,
    private targetService: TargetService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createAssignTargetForm();
    if (this.fromSalesPerson && this.salesperson) {

      this.assignTargetForm.patchValue({
        salesperson: this.salesperson.id
      });
      this.getTargets();
    } else {
      if (!this.target) return;
      this.getSalespersons();
      this.getSubperiods();
      this.setCurrencyEnabledStatusForAssignedTarget();
      this.getTargetLimit();
    }
  }


  closeModal() {
    this.generalService.modal.closeActive()

  }

  ngAfterViewInit(): void {
    //@ts-ignore
    const targetModal = document.querySelector("[data-target='#targetModal']")
    if (targetModal)
      targetModal.addEventListener("click", () => {
        this.showTargetModal = true;
      });
  }

  getTargets(filter?: any) {
    this.loadingView = true;
    const targets = this.targetService.getTargets(
      this.targetService.convertObjectToQueryString(filter || {}) || ''
    )
    if (!targets) return;
    targets.subscribe((res: any) => {
      this.loadingView = false;
      if (res.status === 200) {
        this.targets = res.response.map((e: any) => {
          return { ...e, id: e.id, description: `${e.title} (${e.type})` };
        });
      }
    });
  }

  createAssignTargetForm() {
    this.assignTargetForm = this.fb.group({
      salesperson: ["", Validators.required],
      subperiod: ["", Validators.required],
      value: ["",
        [
          Validators.required,
          CustomValidators.number
        ]
      ],
      stage: [""]
    });
  }

  private async getSalespersons() {
    try {
      const type = 5;
      const salesPersonList = await this.salepersonSrv
        .fetchSalesperson(type)
        .toPromise();
      this.salespersonList = salesPersonList.filter(
        ({ userRel }: any) => userRel.salesPerson
      );
    } catch (error) { }
  }
  getSubperiods() {

    const targetStageList$ = this.targetService.getTargetStagesDropdown(this.target.type);
    if (targetStageList$) {
      targetStageList$.subscribe((res: any) => {
        this.targetStageList = res;
        this.setCurrencyEnabledStatusForAssignedTarget();
      });
    }

    const subperiodsObs$ = this.targetService.getTargetPeriods(this.target.id);
    if (!subperiodsObs$) return;
    subperiodsObs$.subscribe((res: any) => {
      if (res.status === 200)
        this.subperiods = res.response;
      this.getTargetLimit();
    });
  }



  private getPeriods() {
    const periods = this.targetService.getPeriods();
    if (!periods) return;
    periods.subscribe((res: any) => {
      if (res.status === 200) {
        this.periods = new Observable(observer => {
          observer.next(res.response.map((e: any) => {
            return { id: e.id, description: e.name, ...e };
          }));
        });
      }
    });
  }

  setCurrencyEnabledStatusForAssignedTarget() {
    this._isCurrencyEnabledForAssigned = (
      this.target.type === 'revenue' ||
      this.target.type === 'markup' ||
      this.target.type === 'product_revenue'
    ) ? true : false;
    const valueControl = this.assignTargetForm.get('value');
    if (valueControl !== null) {
      if (this._isCurrencyEnabledForAssigned) {
        valueControl.setValidators([Validators.required, CustomValidators.number]);
      } else {
        valueControl.setValidators([Validators.required, CustomValidators.digits]);
      }
      valueControl.updateValueAndValidity();
    }
  }
  private getTargetLimit() {
    const targetLimitObs$ = this.targetService.getTargetLimit(this.target.id)
    if (!targetLimitObs$) return;
    targetLimitObs$
      .subscribe((res: any) => {
        if (res.status === 200)
          this.target_limit = res.response.unallocated;
      });
  }

  handleChangeInTarget(targetID: any) {
    this.target = this.targets.find((e: any) => +e.id === +targetID);
    this.getSubperiods();
    this.setCurrencyEnabledStatusForAssignedTarget();
    this.getTargetLimit();
  }

  assignTarget() {
    const targetDetails = this.assignTargetForm.value;
    this.generalService.sweetAlertFileAssign("Target").then(res => {
      if (res.value) {
        let obj: any = {
          userId: targetDetails.salesperson,
          targetId: this.target.id,
          sub_periodId: targetDetails.subperiod,
          value: targetDetails.value,
          periodId: this.target.period
        };
        if (targetDetails.stage) {
          obj['stage'] = targetDetails.stage;
        }

        if (!obj.targetId || !obj.sub_periodId || !obj.value)
          return this.generalService.notification(
            "Kindly fill all required field(s)",
            "",
            "warning"
          );
        if (parseFloat(obj.value) > this.target_limit) {
          return this.generalService.notification(
            `Insufficient unallocated target (${this.target_limit})`,
            "",
            "warning"
          );
        }
        this.loading = true;
        const addAssignedTargetObs$ = this.isTeam ? this.targetService.addAssignedTeamTarget(obj) : this.targetService.addAssignedTarget(obj);
        if (!addAssignedTargetObs$) return;
        addAssignedTargetObs$
          .subscribe((response: any) => {
            this.loading = false;
            if (response.status === 200) {
              this.generalService.notification(
                "Target assigned successfully!",
                "",
                "success"
              );
              this.assignTargetForm.reset();
              this.getTargetLimit();
              this.closeModal();
            } else {
              this.generalService.notification(response.error, "", "error");
              this
            }
          },
            error => {
              this.loading = false;
              this.generalService.sweetAlertError(this.generalService.getErrMsg(error));
            }
          );
      }
    });
  }

}
